/**
 * TOP - 配達可能エリアセクション
 */
{
  if(window.location.pathname !== '/cart')  {
    const prefSelectBox = document.getElementById("pref_select"); //都道府県選択用セレクトボックス
    const citySelectBox = document.getElementById("area_select"); //市区選択用セレクトボックス
    
    //県エリアセレクト変更時
    prefSelectBox.addEventListener("change", () => {
      removeSpanElement(citySelectBox); //選択市区エリアのoptionの親要素からspanを削除する(SP対策)
      changeSelectArea(prefSelectBox.value, citySelectBox); //選択市区エリア変更
      dispSelectInfo(citySelectBox); //金額表示エリアだし分け
    });
  
    //市区エリアセレクト変更時
    citySelectBox.addEventListener("change", () => {
      changeSelectInfo(prefSelectBox, citySelectBox); //選択情報表示エリアの内容変更
      dispSelectInfo(citySelectBox); //選択情報表示エリアだし分け
    });

    //ページロード時(渋谷区が選択された状態に)
    window.addEventListener('DOMContentLoaded',() => {
        prefSelectBox.value = "tokyo";
        removeSpanElement(citySelectBox); //選択市区エリアのoptionの親要素からspanを削除する(SP対策)
        changeSelectArea(prefSelectBox.value, citySelectBox); //選択市区エリア変更
        citySelectBox.value =  "渋谷区";
        changeSelectInfo(prefSelectBox, citySelectBox); //選択情報表示エリアの内容変更
        dispSelectInfo(citySelectBox); //金額表示エリアだし分け
    });
  }

  //市区オプションの親要素にspanが入っている場合は、spanを削除する
  function removeSpanElement(citySelectBox) {
    const cityOptionsArray = Array.from(citySelectBox.children); //市区オプション一覧配列

    cityOptionsArray.forEach((areaOption) => {
      if(areaOption.tagName === "SPAN") {
        const optionElement = areaOption.firstChild;
        areaOption.parentNode.insertBefore(optionElement, areaOption);
        areaOption.parentNode.removeChild(areaOption);
        optionElement.hidden = false;
      }
    });
  }
  
  //選択した県ごとに、選択可能なエリアを変更する
  function changeSelectArea(prefecture, citySelectBox) {
    const cityOptionsArray = Array.from(citySelectBox.children); //市区オプション一覧配列  
    citySelectBox.value = "area";
    cityOptionsArray.forEach((areaOption) => {
      if (areaOption.value !== "area" && areaOption.dataset.prefecture !== prefecture ) {
        const spanElement = document.createElement('span');
        spanElement.className = 'selector-hide';
        areaOption.parentNode.replaceChild(spanElement, areaOption);
        spanElement.appendChild(areaOption); 
        areaOption.hidden = true;
      }
    });
  }
  
  //選択情報表示エリアの情報を変更
  function changeSelectInfo(prefSelectBox, citySelectBox) {
    const dispPrefectureArea = document.getElementById("select_prefecture");
    const dispCityArea = document.getElementById("select_city");
    const dispMinPriceArea = document.getElementById("selected_city_minPrice");
    const minPrice = citySelectBox.options[citySelectBox.selectedIndex].dataset.minprice;
  
    dispPrefectureArea.innerText = prefSelectBox.options[prefSelectBox.selectedIndex].text;
    dispCityArea.innerText = citySelectBox.options[citySelectBox.selectedIndex].text;
    dispMinPriceArea.innerText = new Intl.NumberFormat("ja-JP").format(parseInt(minPrice)) + "円";
  }
  
  //選択情報表示エリア表示、非表示切り替え
  function dispSelectInfo(citySelectBox) {
    const selectInfoArea = document.querySelector(".select_info_red");
  
    if (citySelectBox.value !== "area") {
      selectInfoArea.style.display = "block";
    } else {
      selectInfoArea.style.display = "none";
    }
  }
}